import { useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import Icon from '@mdi/react';
import { mdiClose, mdiMapMarkerRadius } from '@mdi/js';
import Button from 'client/components/aria/Button/Button';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { mapModes } from 'client/utils/constants/appStates';
import CollapsibleSnackBar from '../CollapsibleSnackBar/CollapsibleSnackBar';
import { useEffect, useState } from 'react';
import styles from '../button.module.scss';

const CreatingObservationSnackBar = () => {
    const intl = useIntl();

    const mapMode = useSelector(state => state.map?.mode);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        setVisible(mapMode.includes(mapModes.ADDING_OBSERVATION));
    }, [mapMode]);

    const dismissObservationNotification = () => {
        const visibleToggled = !visible;
        setVisible(visibleToggled);
    };
    const closeButton = <Button
        aria-label={ intl.formatMessage({ id: 'general.closeNotification' }) }
        data-testid="observationsSnackBar.close"
        variant="transparent"
        className={styles.button}
        onPress={dismissObservationNotification}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    if (!mapMode.includes(mapModes.ADDING_OBSERVATION)) {
        return <></>;
    }

    return (
        <>
            { visible && <SnackBar variant="info" endOfLine={closeButton} data-testid="observationsSnackBar">
                <CollapsibleSnackBar
                    icon={mdiMapMarkerRadius}
                    label={ intl.formatMessage({ id: 'creatingObservation.notification.label' })}
                    data-testid="creatingObservation.alert">
                    <FormattedMessage
                        id={'creatingObservation.alert'}
                    />
                </CollapsibleSnackBar>
            </SnackBar>
            }
        </>
    );
};

export default CreatingObservationSnackBar;
